<template>
  <el-dialog
    :title="$t('maintenancePopup.title')"
    :visible.sync="visible"
    :show-close="false"
    width="500px"
    custom-class="maintenance-popup"
  >
    <p class="maintenance-popup__body">
      {{ $t('maintenancePopup.body1') }}
    </p>
    <p class="maintenance-popup__body">
      {{ $t('maintenancePopup.body2') }}
    </p>
    <p class="maintenance-popup__body">
      {{ $t('maintenancePopup.contactPrefix') }}
      <a
        class="maintenance-popup__email"
        href="mailto:info_sami@complifegroup.com"
      >
        info_sami@complifegroup.com</a>
    </p>
    <p
      v-if="$t('maintenancePopup.closing')"
      class="maintenance-popup__body"
    >
      {{ $t('maintenancePopup.closing') }}
    </p>
    <span
      slot="footer"
      class="maintenance-popup__footer"
    >
      <el-button
        type="primary"
        @click="visible = false"
      >
        {{ $t('maintenancePopup.closeButton') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'MaintenancePopup',
  data() {
    return { visible: false };
  },
  created() {
    const withinPeriod = new Date() <= new Date('2026-05-03T23:59:59');
    const alreadyShown = sessionStorage.getItem('maintenancePopupShown');
    this.visible = withinPeriod && !alreadyShown;
    if (this.visible) sessionStorage.setItem('maintenancePopupShown', '1');
  },
};
</script>

<style lang="scss">
.maintenance-popup {
  .el-dialog__header {
    padding: 16px 20px 12px;
  }

  .el-dialog__title {
    display: block;
    text-align: center;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.3;
  }

  .el-dialog__body {
    padding: 0 20px 16px;
  }

  .el-dialog__footer {
    padding: 12px 20px 20px;
  }

  &__body {
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    margin: 0 0 0.625rem;
    word-break: keep-all;
  }

  &__email {
    font-size: 0.875rem;
    font-weight: 500;
  }

  &__footer {
    display: flex;
    justify-content: center;
  }
}
</style>
